import React from 'react';
import Head from 'next/head';

// تعریف نوع پروپ های کانفیگ سئو
interface SeoConfig {
    description?: string;
    imageUrl?: string;
    siteUrl?: string;
    keywords?: string;
    /** hreflang → absolute URL for every language version of this page. */
    alternates?: { hreflang: string; href: string }[];
    locale?: string;
}

const HeadMeta = ({ title, seoConfig }: { title: string, seoConfig?: SeoConfig; disableProgress?: boolean }) => {
    const titleFull = title.toLowerCase().includes('mynawoo') ? title : `${title} | Mynawoo`;
    const webMcpOriginTrialToken = process.env.NEXT_PUBLIC_WEBMCP_ORIGIN_TRIAL_TOKEN;

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                {webMcpOriginTrialToken && (
                    <meta httpEquiv="origin-trial" content={webMcpOriginTrialToken} />
                )}
                {/* Favicon */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
                <meta name="viewport" content={seoConfig ? "width=device-width, initial-scale=1.0, maximum-scale=5" : "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"} />

                {/* Title */}
                <title>{titleFull}</title>

                {!seoConfig && (
                    <meta name="robots" content="noindex, nofollow" />
                )}

                {seoConfig && (
                    <>
                        <meta name="robots" content="index, follow, max-image-preview:large" />

                        {/* Meta Description */}
                        <meta name="description" content={seoConfig?.description} />

                        {/* Canonical URL */}
                        <link rel="canonical" href={seoConfig?.siteUrl || "https://mynawoo.com"} />

                        <meta property="og:title" content={titleFull} />
                        <meta property="og:description" content={seoConfig?.description} />
                        <meta property="og:image" content={seoConfig?.imageUrl} />
                        <meta property="og:url" content={seoConfig?.siteUrl || "https://mynawoo.com"} />
                        <meta property="og:type" content="website" />
                        <meta property="og:site_name" content="mynawoo" />
                        {seoConfig?.locale && <meta property="og:locale" content={seoConfig.locale.replace('-', '_')} />}
                        {seoConfig?.alternates?.map(alt => (
                            <link key={alt.hreflang} rel="alternate" hrefLang={alt.hreflang} href={alt.href} />
                        ))}

                        {/* Twitter Card Tags */}
                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content={titleFull} />
                        <meta name="twitter:description" content={seoConfig?.description} />
                        <meta name="twitter:image" content={seoConfig?.imageUrl} />
                        {/* <meta name="twitter:site" content="@YourTwitterHandle" /> */}

                        {/* Theme Color */}
                        <meta name="theme-color" content="#7A5DE4" />

                        {/* Additional meta */}
                        <meta name="keywords" content={seoConfig?.keywords} />

                    </>
                )}
            </Head>
        </>
    );
}

export default HeadMeta;
